(function(){
  var S='https://drivers.checkmot.com/pages/driving-instructors-';
  var DW=window.DW||{towns:[],districts:{},regions:[]};
  var q=document.getElementById('q'),res=document.getElementById('results'),form=document.getElementById('finder'),reg=document.getElementById('region');
  var fmt=function(n){return n.toLocaleString('en-GB');};
  if(DW.total){document.getElementById('dw-total').textContent=fmt(DW.total);document.getElementById('dw-towns').textContent=DW.towns.length;}
  function norm(s){return s.toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim();}
  function outward(s){
    var t=s.toUpperCase().replace(/\s+/g,'');
    var m=t.match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})$/); if(m) return m[1];
    m=t.match(/^([A-Z]{1,2}\d[A-Z\d]?)$/); if(m) return m[1];
    return null;
  }
  function row(href,name,meta){
    var li=document.createElement('li'),a=document.createElement('a');a.href=href;
    var b=document.createElement('b');b.textContent=name;var sm=document.createElement('small');sm.textContent=meta;
    a.appendChild(b);a.appendChild(sm);li.appendChild(a);return li;
  }
  function msg(t){var li=document.createElement('li');li.className='msg';li.textContent=t;return li;}
  function search(v){
    var out=[];v=(v||'').trim(); if(!v) return out;
    var d=outward(v);
    if(d){
      var list=DW.districts[d]||[];
      list.forEach(function(x){var t=DW.towns[x[0]];out.push({h:S+t[2]+'#d-'+d.toLowerCase(),n:d+' · '+t[0],m:x[1]+' instructor'+(x[1]==1?'':'s')});});
      if(out.length) return out;
      var area=d.replace(/\d.*$/,''),seen={};
      Object.keys(DW.districts).forEach(function(k){if(k.replace(/\d.*$/,'')===area){DW.districts[k].forEach(function(x){if(!seen[x[0]]){seen[x[0]]=1;var t=DW.towns[x[0]];out.push({h:S+t[2],n:t[0],m:'',c:x[1]});}});}});
      out.sort(function(a,b){return b.c-a.c;});out.forEach(function(o){o.m=area+' postcode area';});return out.slice(0,8);
    }
    var n=norm(v);
    DW.towns.forEach(function(t){var tn=norm(t[0]);var i=tn.indexOf(n);if(i>-1){out.push({h:S+t[2],n:t[0],m:fmt(t[1])+' instructors · '+DW.regions[t[3]],s:(i===0?0:1)});}});
    out.sort(function(a,b){return a.s-b.s||a.n.localeCompare(b.n);});
    return out.slice(0,8);
  }
  function render(v,submitted){
    res.innerHTML='';var r=search(v);
    if(!v.trim()) return;
    if(!r.length){res.appendChild(msg(submitted?'No match yet. Try the first part of your postcode (e.g. TW3) or a nearby town, or browse by region below.':'Keep typing a postcode or town…'));return r;}
    r.forEach(function(x){res.appendChild(row(x.h,x.n,x.m));});return r;
  }
  q&&q.addEventListener('input',function(){render(q.value,false);});
  form&&form.addEventListener('submit',function(e){e.preventDefault();var r=render(q.value,true);if(r&&r.length===1){window.location.href=r[0].h;}});
  reg&&reg.addEventListener('change',function(){if(reg.value) window.location.href=reg.value;});
  // filter chips
  var chips=document.querySelectorAll('.chip'),cards=document.querySelectorAll('#grid .card');
  chips.forEach(function(c){c.addEventListener('click',function(){
    var f=c.getAttribute('data-f');
    chips.forEach(function(o){var on=o===c;o.classList.toggle('is-on',on);o.setAttribute('aria-pressed',on?'true':'false');});
    cards.forEach(function(k){k.hidden=!(f==='all'||k.getAttribute('data-cat')===f);});
  });});
  // mobile drawer
  var bt=document.querySelector('.hdr__burger'),dr=document.getElementById('drawer');
  bt&&bt.addEventListener('click',function(){var open=dr.hidden;dr.hidden=!open;bt.setAttribute('aria-expanded',open?'true':'false');});
  window.__dwSearch=search;
})();
